"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrivateChatRoom = exports.PRIVATE_CHAT_ROOM_TYPES = void 0;
const types_1 = require("./types");
exports.PRIVATE_CHAT_ROOM_TYPES = [types_1.ChatRoomType.ONE_TO_ONE, types_1.ChatRoomType.JOB_GROUP];
function isPrivateChatRoom(type) {
    return exports.PRIVATE_CHAT_ROOM_TYPES.includes(type);
}
exports.isPrivateChatRoom = isPrivateChatRoom;
